module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('b-alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.showTop),
      callback: function($$v) {
        _vm.showTop = $$v
      },
      expression: "showTop"
    }
  }, [_c('span', {
    staticClass: "icon-info-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('LNG_ERROR', this.lang)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('LNG_TEST_NOT_DELETED', this.lang)))])]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('h3', [_vm._v(_vm._s(_vm.$t('LNG_MAINVIEW_TITLE', this.lang)))])])], 1), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "10",
      "offset": "1"
    }
  }, [_c('div', {
    attrs: {
      "id": "tests"
    }
  }, [_c('v-client-table', {
    attrs: {
      "data": _vm.testData,
      "columns": _vm.testsColumns,
      "options": _vm.testsOptions
    },
    scopedSlots: _vm._u([{
      key: "editTest",
      fn: function(props) {
        return _c('div', {
          staticClass: "fa fa-edit",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.editATest(props.row.id)
            }
          }
        })
      }
    }, {
      key: "deleteTest",
      fn: function(props) {
        return (props.row.shared !== 1) ? _c('div', {
          staticClass: "fa fa-trash",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.deleteATest(props.row.id)
            }
          }
        }) : _vm._e()
      }
    }, {
      key: "wordButton",
      fn: function(props) {
        return (props.row.word) ? _c('div', {
          staticClass: "fa fa-file",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.openWord(props.row.id)
            }
          }
        }) : _vm._e()
      }
    }, {
      key: "pdfButton",
      fn: function(props) {
        return (props.row.pdf) ? _c('div', {
          staticClass: "fa fa-paperclip",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.openPdf(props.row.id)
            }
          }
        }) : _vm._e()
      }
    }, {
      key: "share",
      fn: function(props) {
        return (props.row.shared !== 1) ? _c('div', {
          staticClass: "fa fa-share-alt",
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.openShareBox(props.row.id)
            }
          }
        }) : _vm._e()
      }
    }], true)
  })], 1)])], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "effect": "fade",
      "title": _vm.$t('LNG_NEW_TEST', this.lang)
    },
    on: {
      "shown": _vm.setModalInputFocus
    },
    model: {
      value: (_vm.fileModalNewTest),
      callback: function($$v) {
        _vm.fileModalNewTest = $$v
      },
      expression: "fileModalNewTest"
    }
  }, [(_vm.showMissingDataError) ? _c('b-alert', {
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(_vm._s(this.missingDataErrorMsg))]) : _vm._e(), _vm._v(" "), _c('b-form-input', {
    ref: "testName",
    staticClass: "mb-3",
    attrs: {
      "type": "text",
      "required": "",
      "placeholder": _vm.$t('LNG_NAME', this.lang)
    },
    model: {
      value: (_vm.testName),
      callback: function($$v) {
        _vm.testName = $$v
      },
      expression: "testName"
    }
  }), _vm._v(" "), _c('b-form-input', {
    staticClass: "mb-3",
    attrs: {
      "type": "date",
      "placeholder": _vm.$t('LNG_DATE', this.lang)
    },
    model: {
      value: (_vm.testDate),
      callback: function($$v) {
        _vm.testDate = $$v
      },
      expression: "testDate"
    }
  }), _vm._v(" "), _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "options": _vm.selectDiscipline.options
    },
    model: {
      value: (_vm.selectDiscipline.value),
      callback: function($$v) {
        _vm.$set(_vm.selectDiscipline, "value", $$v)
      },
      expression: "selectDiscipline.value"
    }
  }, [_c('template', {
    slot: "first"
  }, [_c('option', {
    attrs: {
      "disabled": ""
    },
    domProps: {
      "value": null
    }
  }, [_vm._v("-- " + _vm._s(_vm.$t('LNG_SELECT_DISCIPLINE_DEFAULT', this.lang)) + " --")])])], 2), _vm._v(" "), _c('b-form-select', {
    staticClass: "mb-3",
    attrs: {
      "multiple": "",
      "options": _vm.selectTestGroup.options
    },
    model: {
      value: (_vm.selectTestGroup.value),
      callback: function($$v) {
        _vm.$set(_vm.selectTestGroup, "value", $$v)
      },
      expression: "selectTestGroup.value"
    }
  }), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "rows": "5",
      "id": "comment",
      "placeholder": _vm.$t('LNG_TEST_COMMENTS', this.lang)
    },
    model: {
      value: (_vm.comment),
      callback: function($$v) {
        _vm.comment = $$v
      },
      expression: "comment"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exitFileModalNewTest()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.createNewTest($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CREATE', _vm.lang)))])], 1)], 1), _vm._v(" "), _c('b-modal', {
    attrs: {
      "effect": "fade"
    },
    model: {
      value: (_vm.fileModalShareTest),
      callback: function($$v) {
        _vm.fileModalShareTest = $$v
      },
      expression: "fileModalShareTest"
    }
  }, [(_vm.showErrorSharedStatusChange) ? _c('div', {
    staticClass: "alert alert-danger",
    attrs: {
      "role": "alert"
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('LNG_ERROR_UPDATING_SHARING_STATUS', this.lang)) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal-header",
    attrs: {
      "slot": "modal-header"
    },
    slot: "modal-header"
  }, [_c('h4', {
    staticClass: "modal-title"
  }, [_c('b', [_vm._v(_vm._s(_vm.$t('LNG_MANAGE_SHARING', this.lang)))])])]), _vm._v(" "), _c('v-client-table', {
    attrs: {
      "data": _vm.teacherSharedData,
      "columns": _vm.teacherSharedColumns,
      "options": _vm.teacherSharedOptions
    },
    scopedSlots: _vm._u([{
      key: "shared",
      fn: function(props) {
        return _c('div', {
          staticClass: "fa",
          class: {
            'fa-check': props.row.shared === '1', 'fa-minus-circle': (props.row.shared === null || props.row.shared === '0')
          },
          staticStyle: {
            "cursor": "pointer"
          },
          on: {
            "click": function($event) {
              return _vm.changeSharedStatus(props.row.id)
            }
          }
        })
      }
    }, {
      key: "can_edit",
      fn: function(props) {
        return (props.row.shared === '1') ? _c('div', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (false),
            expression: "false"
          }],
          staticClass: "fa"
        }, [_c('b-form-checkbox', {
          on: {
            "change": function($event) {
              return _vm.editModeClicked(props.row.id)
            }
          },
          model: {
            value: (_vm.canEditArray[props.row.id]),
            callback: function($$v) {
              _vm.$set(_vm.canEditArray, props.row.id, $$v)
            },
            expression: "canEditArray[props.row.id]"
          }
        })], 1) : _vm._e()
      }
    }], true)
  }), _vm._v(" "), _c('div', {
    staticClass: "modal-footer",
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exitModalShareTest()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', this.lang)))])])], 1), _vm._v(" "), _c('b-alert', {
    attrs: {
      "placement": "top",
      "duration": "3000",
      "type": "danger",
      "width": "400px",
      "dismissable": ""
    },
    model: {
      value: (_vm.showAlertNoLicence),
      callback: function($$v) {
        _vm.showAlertNoLicence = $$v
      },
      expression: "showAlertNoLicence"
    }
  }, [_c('span', {
    staticClass: "icon-ok-circled alert-icon-float-left"
  }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(_vm.$t('LNG_WARNING_VERSION', this.lang)))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.$t('LNG_YOU_USE_THE_FREE_VERSION', this.lang)))])]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": _vm.$t('LNG_CONFIRM_TEST_DELETION', this.lang),
      "cancel-title": _vm.$t('LNG_CANCEL', this.lang),
      "ok-variant": "evaobj",
      "ok-title": _vm.$t('LNG_DELETE', this.lang)
    },
    on: {
      "ok": _vm.okDeleteTestAction,
      "cancel": _vm.cancelAction
    },
    model: {
      value: (_vm.showDeleteModal),
      callback: function($$v) {
        _vm.showDeleteModal = $$v
      },
      expression: "showDeleteModal"
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t('LNG_DO_YOU_REALLY_WANT_TO_DELETE_THE_TEST', this.lang)) + "\n    ")]), _vm._v(" "), _c('b-modal', {
    attrs: {
      "title": _vm.$t('LNG_SEND_A_FILE', this.lang),
      "size": "lg"
    },
    model: {
      value: (_vm.fileModalStudents),
      callback: function($$v) {
        _vm.fileModalStudents = $$v
      },
      expression: "fileModalStudents"
    }
  }, [_c('b-alert', {
    attrs: {
      "variant": "danger"
    },
    model: {
      value: (_vm.displayStudentImportAlert),
      callback: function($$v) {
        _vm.displayStudentImportAlert = $$v
      },
      expression: "displayStudentImportAlert"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('LNG_STUDENT_IMPORT_WARNING', this.lang, {
    importedStudents: this.importedStudents
  })) + " "), _c('br'), _vm._v("\n          " + _vm._s(_vm.$t('LNG_STUDENT_IMPORT_ERRORMESSAGE', this.lang, {
    errorMessage: this.errorMessage
  })) + "\n      ")]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "warning"
    },
    model: {
      value: (_vm.displayStudentImportWarning),
      callback: function($$v) {
        _vm.displayStudentImportWarning = $$v
      },
      expression: "displayStudentImportWarning"
    }
  }, [_vm._v("\n          " + _vm._s(_vm.$t('LNG_STUDENT_IMPORT_WARNING', this.lang, {
    importedStudents: this.importedStudents
  })) + " "), _c('br'), _vm._v("\n          " + _vm._s(_vm.$t('LNG_STUDENT_IMPORT_ERRORMESSAGE', this.lang, {
    errorMessage: this.errorMessage
  })) + "\n       ")]), _vm._v(" "), _c('b-alert', {
    attrs: {
      "variant": "success"
    },
    model: {
      value: (_vm.displayStudentImportSuccess),
      callback: function($$v) {
        _vm.displayStudentImportSuccess = $$v
      },
      expression: "displayStudentImportSuccess"
    }
  }, [_vm._v("\n         " + _vm._s(_vm.$t('LNG_STUDENT_IMPORT_SUCCESS', this.lang, {
    number: this.importedStudents
  })) + "\n      ")]), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_c('b-form-checkbox', {
    attrs: {
      "value": "1"
    },
    model: {
      value: (_vm.studentFileHasHeader),
      callback: function($$v) {
        _vm.studentFileHasHeader = $$v
      },
      expression: "studentFileHasHeader"
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_STUDENT_SEND_A_FILE_WITH_HEADER', this.lang)))])], 1), _vm._v(" "), _c('p', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.$t('LNG_STUDENT_FILE_DESCRIPTION', this.lang)))]), _vm._v(" "), _c('b-form-file', {
    ref: "fileinput",
    attrs: {
      "accept": ".csv",
      "state": Boolean(_vm.studentFile),
      "placeholder": _vm.$t('LNG_FILE', _vm.lang),
      "required": ""
    },
    model: {
      value: (_vm.studentFile),
      callback: function($$v) {
        _vm.studentFile = $$v
      },
      expression: "studentFile"
    }
  }), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "modal-footer"
    },
    slot: "modal-footer"
  }, [_c('b-button', {
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.exitFileModalStudents()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CLOSE', _vm.lang)))]), _vm._v(" "), _c('b-button', {
    attrs: {
      "variant": "evaobj",
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.sendFileStudents($event)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('LNG_CREATE', _vm.lang)))])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-cfd9fdc6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/mainview.vue
// module id = 884
// module chunks = 1